import React, { useState } from 'react';
import { FormikValues, useFormik } from 'formik';

import { Component } from './component';
import { useMutation, useQueryClient } from 'react-query';
import { FORM_VALUE_ENUM, FORM_VALUE_TYPE } from './constant';
import { createPopup } from './action';
import { validation } from '../../lib/validation';
import { SELECT_OPTION_ITEM_DATA } from '../../common/select';
import { required, urlOptional } from '../../lib/validation/service';
import { ACTION_ERROR_INTER } from '../event-list/constant';
import { convert } from './convert';
import { POPUP_ADMIN_LIST_MODULE_NAME } from '../admin-popup-list';
import { POPUP_LIST_MODULE_NAME } from '../popup-list';

export const Container: React.FC<{}> = ({}) => {
  const [isOpen, setIsOpen] = useState(false);

  const query = useQueryClient();

  const onSuccess = () => {
    setIsOpen(false);
    query.invalidateQueries(POPUP_ADMIN_LIST_MODULE_NAME);
    query.invalidateQueries(POPUP_LIST_MODULE_NAME);

    formik.resetForm();
  };

  const action = useMutation(
    () => {
      return createPopup(convert(formik.values));
    },
    {
      onSuccess,
    },
  );

  const config = {
    [FORM_VALUE_ENUM.BODY]: [required],
    [FORM_VALUE_ENUM.IMG_URL]: [urlOptional],
    [FORM_VALUE_ENUM.LINK_URL]: [urlOptional],
    [FORM_VALUE_ENUM.DEADLINE]: [required],
    [FORM_VALUE_ENUM.LANG]: [required],
  };

  const validate = (values: FormikValues) => validation(values, config);

  const initialValues = {
    [FORM_VALUE_ENUM.BODY]: '',
    [FORM_VALUE_ENUM.DEADLINE]: '',
    [FORM_VALUE_ENUM.IMG_URL]: '',
    [FORM_VALUE_ENUM.LINK_URL]: '',
    [FORM_VALUE_ENUM.LANG]: '',
  };

  const formik: FormikValues = useFormik({
    initialValues,
    validate,
    onSubmit: () => {
      return action.mutate();
    },
  });

  const isFieldError = (name: FORM_VALUE_TYPE): boolean => {
    return formik.errors[name] && formik.touched[name] ? true : false;
  };

  const getFieldError = (name: FORM_VALUE_TYPE): string | undefined =>
    isFieldError(name) ? formik.errors[name] : undefined;

  const isSubmitDisabled = () => {
    if (!formik.isValid) {
      return true;
    }
    if (!formik.dirty) {
      return true;
    }
    if (action.isLoading) {
      return true;
    }
  };

  const isLoading = () => {
    if (action.isLoading) {
      return true;
    }
  };

  const isSuccess = () => {
    if (action.isSuccess) {
      return true;
    }
  };

  const getErrorMessage = () => {
    const error: ACTION_ERROR_INTER = action.error as ACTION_ERROR_INTER;
    if (error) {
      return error.message;
    }
  };

  const isError = () => {
    if (action.isError && !action.isLoading && getErrorMessage()) {
      return true;
    }
  };

  const getFieldValue = (name: FORM_VALUE_TYPE) => formik.values[name];

  const setFieldValue = (name: FORM_VALUE_TYPE, e: SELECT_OPTION_ITEM_DATA) => {
    formik.setFieldValue(name, Array.isArray(e) ? e : [e]);
  };

  const handleButtonClick = () => {
    setIsOpen(true);
  };

  return (
    <Component
      handleButtonClick={handleButtonClick}
      isOpen={isOpen}
      setFieldValue={setFieldValue}
      isFieldError={isFieldError}
      getFieldValue={getFieldValue}
      getFieldError={getFieldError}
      isSubmitDisabled={isSubmitDisabled}
      isLoading={isLoading()}
      isSuccess={isSuccess()}
      isError={isError()}
      formik={formik}
    />
  );
};
